import { SetLoadingAction } from '../reducers/mainReducer'
import { type_MAIN_LOADING } from '../types'

export function mainSetLoading(payload: boolean): SetLoadingAction {
    return {
        type: type_MAIN_LOADING,
        payload,
    }
}
